export default "__VITE_ASSET__vMuyATXJ__"